import { render, staticRenderFns } from "./_quotations.vue?vue&type=template&id=2756ec90&scoped=true&"
import script from "./_quotations.vue?vue&type=script&lang=js&"
export * from "./_quotations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2756ec90",
  null
  
)

export default component.exports